import { Overlay } from "@smart/itops-sb-design-system-dom";

const NotFound = () => (
  <Overlay icon="regularCircleExclamation" subHeading="Page Not Found" />
);

const ConditionalNotFound = ({
  show,
  element,
}: {
  show: boolean | undefined;
  element: React.ReactElement;
}) => (show ? element : <NotFound />);

export { NotFound, ConditionalNotFound };
